import axios from 'axios';
import { isNull } from 'util';

export default {
  namespaced: true,
  state: {
    token: null,
  },
  mutations: {
    setToken(state, data) {
      state.token = data;
    },
  },
  actions: {
    async signIn({ commit }, {
      email, password, onSuccess, onFailure,
    }) {
      const params = { email, password };

      try {
        const response = await axios.post('/api/users/signIn', params);
        const token = response.data;

        commit('setToken', token);

        if (!isNull(token)) {
          onSuccess();
        } else {
          onFailure();
        }

        return true;
      } catch (error) {
        console.log(error);
        commit('setToken', null);
        onFailure();

        return false;
      }
    },
    async signUp({ commit }, {
      email, password, onSuccess, onFailure,
    }) {
      const params = { email, password };

      try {
        const response = await axios.post('/api/users/signUp', params);
        const token = response.data;

        commit('setToken', token);

        if (!isNull(token)) {
          onSuccess();
        } else {
          onFailure();
        }

        return true;
      } catch (error) {
        console.log(error);
        commit('setToken', null);
        onFailure();

        return false;
      }
    },
    async logOut({ commit, state }) {
      try {
        // wyloguj lokalnie natychmiast
        const params = { token: state.token };
        commit('setToken', null);
        await axios.post('/api/users/logOut', params);

        return true;
      } catch (error) {
        console.log(error);
        commit('setToken', null);

        return false;
      }
    },
  },
  getters: {
    userSignedIn: state => !isNull(state.token),
  },
};
